require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./association-dalumni-0-10-2.json") })
        }
      }, "path---association-dalumni-0-10-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---association-dalumni-0-10-2!./.cache/json/association-dalumni-0-10-2.json
// module id = 336
// module chunks = 231608221292675